module.exports = __webpack_public_path__ + "static/media/buildings.1b61d67d.svg";